import React from 'react';
import { PageHero } from '../components/PageHero';
import { Product as ProductSection } from '../components/Product';
import { PeriscanOperators } from '../components/PeriscanOperators';
import { Workflow } from '../components/Workflow';
import { FirstReport } from '../components/FirstReport';
import { Integrations } from '../components/Integrations';
import { Competitive } from '../components/Competitive';
import { SectionStage } from '../components/SectionStage';
import { FrontierGatewayTeaser } from '../components/FrontierGatewayTeaser';
export function Product() {
  return <>
      <PageHero eyebrow="Autonomous Security Validation" title="One platform." titleMuted="Continuous proof." description="A self-serve, agentless platform that finds the paths that matter, walks them safely, and proves what's actually exploitable. No sales calls, no enterprise rollout circus — just continuous proof." bg="none" data-id="element-1844" />
      <SectionStage fx="aurora-particles" data-id="element-1845">
        <ProductSection data-id="element-1846" />
      </SectionStage>

      {/* Periscan Operators — rendered without SectionStage so the cinematic
                      blur/opacity transform doesn't dampen the radar sweep behind it. */}
      <PeriscanOperators data-id="element-1847" />

      <SectionStage fx="orbit" data-id="element-1848">
        <FrontierGatewayTeaser data-id="element-1849" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1850">
        <Workflow data-id="element-1851" />
      </SectionStage>
      <SectionStage fx="beams-squares" data-id="element-1852">
        <FirstReport data-id="element-1853" />
      </SectionStage>
      <SectionStage fx="constellation" data-id="element-1854">
        <Integrations data-id="element-1855" />
      </SectionStage>
      <SectionStage fx="lightning" data-id="element-1856">
        <Competitive data-id="element-1857" />
      </SectionStage>
    </>;
}